import styled from 'styled-components';

import { InputOptionSt } from '~molecules/InputOption';

export const Container = styled.fieldset(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10rem',

  margin: 0,
  border: 'none',

  fontFamily: theme.typography.family.arial,

  '& label': {
    position: 'relative',
  },

  [`${InputOptionSt.Container}`]: {
    maxInlineSize: '220rem',
  },
}));

export const Legend = styled.legend(({ theme }) => ({
  width: '100%',
  paddingBlock: '10rem',
  paddingInlineStart: '4rem',
  borderBlockEnd: `1rem solid ${theme.filter.primary.border}`,
  marginBlockEnd: '10rem',
}));

export const Qty = styled.span(({ theme }) => ({
  color: theme.palette.erieBlack,
  display: 'inline-block',
  marginLeft: 'auto',
  position: 'absolute',
  right: '-10rem',
}));

export const OptionLabel = styled.div(({ theme }) => ({
  color: theme.palette.erieBlack,
}));
